<script lang="ts">

    export let text: string = '';
    export let fontSize: number = 14;
</script>


<div style="font-size: {fontSize}px;" on:click>
    {text}
</div>


<style>
    div {
        color: var(--analytics-red);
        padding: 2px 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
</style>